import { render, staticRenderFns } from "./ColorWariantModal.vue?vue&type=template&id=42202bf0&scoped=true&"
import script from "./ColorWariantModal.vue?vue&type=script&lang=js&"
export * from "./ColorWariantModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42202bf0",
  null
  
)

export default component.exports